import { PostBox } from 'pages/home/Home.style';
import React, { useContext, useEffect, useState } from 'react';
import { SettingsStyles } from './Settings.styles';
import AccountInformation from './AccountInformation';
import clsx from 'clsx';
import { useLocation, useNavigate } from 'react-router-dom';
import DynModel from 'components/Modal';
import { useDispatch } from 'react-redux';
// import { GetLoginResponse } from 'redux/features/LoginSlice';
import { Button } from 'components';
import NetworkInformation from './NetworkInformation';
import LanguageInformation from './LanguageInformation';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import DisplaySetting from './DisplaySetting';
import PrivacySetting from './PrivacySetting';

import { ReactComponent as Arrowforward } from 'assert/images/Common/arrowForward.svg';
import { getProfile } from 'redux/features/ProfileSlice';
import { AuthContext } from 'router/AuthProvider';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';
import { handleClearAllValue } from 'redux/features/LoginSlice';

export default function Settings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;
  const { recheckAuth } = useContext(AuthContext);

  const [activeIndex, setActiveIndex] = useState(0);
  const [openLogoutModel, setOpenLogoutModel] = useState(false);
  const [hideMain, setHideMain] = useState(false);
  const [hideSideMain, setHideSideMain] = useState(false);

  const settingsMenu = [
    {
      id: 1,
      name: t('Settings.AccountInformation'),
      path: '/settings/account',
    },
    {
      id: 2,
      name: t('Settings.NetworkInformation'),
      path: '/settings/network',
    },
    { id: 3, name: t('Settings.Language'), path: '/settings/language' },
    { id: 4, name: t('Settings.Display'), path: '/settings/display' },
    { id: 5, name: t('Settings.Privacy'), path: '/settings/privacy' },
    { id: 6, name: t('Settings.Logout') },
  ];
  const settingsPath = [
    '/settings/account',
    '/settings/network',
    '/settings/language',
    '/settings/display',
    '/settings/privacy',
  ];

  useEffect(() => {
    if (isSmallScreen) {
      if (settingsPath.includes(pathname)) {
        setHideMain(true);
        setHideSideMain(false);
      }
      if (pathname === '/settings') {
        setHideSideMain(true);
        setHideMain(false);
      }
    } else {
      setHideMain(false);
      setHideSideMain(false);
    }
  }, [pathname, isSmallScreen]);

  useEffect(() => {
    if (settingsPath.includes(pathname)) {
      const slideIndex = settingsPath.findIndex((path) =>
        pathname?.endsWith(path)
      );
      setActiveIndex(slideIndex >= 0 ? slideIndex : 0);
    }
  }, [pathname]);

  const handleLogout = () => {
    dispatch(handleClearAllValue())
      .then(() => {
        localStorage.removeItem('token');
        dispatch(getProfile(''));
        recheckAuth();
        navigate('/login');
      })
      .catch(() => {
        localStorage.removeItem('token');
        dispatch(getProfile(''));
        recheckAuth();
        navigate('/login');
      });
  };

  const RenderFunction = () => {
    if (activeIndex === 0) {
      return <AccountInformation />;
    } else if (activeIndex === 1) {
      return <NetworkInformation />;
    } else if (activeIndex === 2) {
      return <LanguageInformation />;
    } else if (activeIndex === 3) {
      return <DisplaySetting />;
    } else if (activeIndex === 4) {
      return <PrivacySetting />;
    }
  };

  return (
    <>
      <Helmet>
        <title>Settings | WafyNet - Manage Your Account</title>
        <meta
          name="description"
          content="Update your personal information, privacy settings, and manage your WafyNet account preferences easily."
        />
      </Helmet>
      <SettingsStyles className="settings-styles">
        <PostBox>
          {!hideMain && (
            <div>
              <div className="setting-title">{t('Settings.Settings')}</div>
              {settingsMenu.map((data, index) => (
                <div
                  key={index}
                  className={clsx(
                    `setting-menu ${activeIndex === index ? 'active' : ''}`
                  )}
                  onClick={() => {
                    if (index === 5) {
                      setOpenLogoutModel(true);
                    } else {
                      if (isSmallScreen && settingsPath.includes(data.path)) {
                        setHideMain(true);
                        setHideSideMain(false);
                      }
                      setActiveIndex(index);
                      navigate(data.path);
                    }
                  }}
                >
                  <div>{data.name}</div>
                  {index !== 5 && <Arrowforward className="right-arrow" />}
                </div>
              ))}
            </div>
          )}
          {!hideSideMain && <div>{RenderFunction()}</div>}
        </PostBox>
        <DynModel
          removeHeader
          modalchanges="headerProfile"
          handleCancelModal={() => setOpenLogoutModel(false)}
          openModal={openLogoutModel}
          content={
            <div className="confirmModal">
              <div className="title">{t('Settings.LogoutConfirmation')}</div>
              <div>
                <Button
                  label={t('Settings.Cancel')}
                  variant="text"
                  onClick={() => setOpenLogoutModel(false)}
                />
                <Button
                  disableElevation
                  label={t('Settings.Yes')}
                  color="error"
                  onClick={handleLogout}
                />
              </div>
            </div>
          }
        />
      </SettingsStyles>
    </>
  );
}
